// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx","776":"component---src-pages-contact-form-tsx"}[chunkId] || chunkId) + "-" + {"245":"0626c20867c26a967bdc","453":"a9f052b0783a8b3be05a","454":"2a10e51c766dcb0229da","776":"7bc27590b1ec17ee434f"}[chunkId] + ".js";
};